export default new class Header {
  constructor() {
    this.headerClass = 'header';
    this.headerFixedClass = 'header__fixed';

    this.init();
  }

  init() {
    const header = $(`.${this.headerClass}`);
    const headerHeight = header.height();
    $(document).scroll(() => {
      const height = $(window).scrollTop();

      if (height > 1) {
        header.addClass(this.headerFixedClass);
        $('body').css({
          paddingTop: `${headerHeight}px`,
        });
      } else {
        header.removeClass(this.headerFixedClass);
        $('body').css({
          paddingTop: 0,
        });
      }
    });
  }
}();
